<!-- change mode: 'auto' hides the back arrow when the form is the only page (a link opened it,
     df-0af813f77a05), because popping the bottom page goes nowhere; Cancel still leaves -->
<cs-header [backButton]="isNewMode() ? false : 'auto'" [fullWidth]="isNewMode()" [separator]="isNewMode()">
  @if (isNewMode()) {
  <cs-icon-button header-left icon="menu" (click)="handleSettingsClick()"></cs-icon-button>
  }
  <cs-header-title [attr.centered]="isNewMode() ? '' : null">
    {{ getPageTitle() }}
    @if (isNewMode()) {
    <cs-header-subtitle>
      {{ LL.intake.step({current: intakeFormState.intakeFormProgress, total: displayedTotalSteps()}) }}
    </cs-header-subtitle>
    }
  </cs-header-title>

  <cs-header-content>
    <!-- Stepper: only in new mode -->
    @if (isNewMode()) {
    <cs-stepper [totalSteps]="displayedTotalSteps()" [currentStep]="intakeFormState.intakeFormProgress"></cs-stepper>
    }

    <!-- Recalculate needed info card: only in non-new mode, tab view, after loading -->
    @if (!isNewMode() && currentView === IntakeView.Tabs) {
    <div class="recalculate-card-wrapper" [class.visible]="!loading && needsPlanRegeneration()">
      <div class="recalculate-card-inner">
        <cs-info-card type="info" [dismissible]="false" [message]="LL.intake.alerts.recalculateNeeded()"
          [actionText]="LL.intake.buttons.recalculate()" (actionClick)="handleRecalculate()">
        </cs-info-card>
      </div>
    </div>
    }

    <!-- Tabs: only in non-new mode, tab view -->
    @if (!isNewMode() && currentView === IntakeView.Tabs) {
    <div class="intake-tabs-wrapper">
      <cs-tab [(selection)]="selectedTab" urlParam="tab" [urlValueMapping]="intakeStepToUrl"
        [valueFromUrlMapping]="urlToIntakeStep">
        <cs-tab-button [value]="IntakeStep.BodyComposition">
          <cs-label>{{ STEP_TITLES[IntakeStep.BodyComposition] }}</cs-label>
        </cs-tab-button>
        <cs-tab-button [value]="IntakeStep.Lifestyle">
          <cs-label>{{ STEP_TITLES[IntakeStep.Lifestyle] }}</cs-label>
        </cs-tab-button>
        <cs-tab-button [value]="IntakeStep.Schedule">
          <cs-label>{{ STEP_TITLES[IntakeStep.Schedule] }}</cs-label>
        </cs-tab-button>
        <cs-tab-button [value]="IntakeStep.Goals">
          <cs-label>{{ STEP_TITLES[IntakeStep.Goals] }}</cs-label>
        </cs-tab-button>
        <cs-tab-button [value]="IntakeStep.TrainingVolume" [disabled]="needsPlanRegeneration()"
          [showNotification]="showTrainingVolumeNotification">
          <cs-label>{{ STEP_TITLES[IntakeStep.TrainingVolume] }}</cs-label>
        </cs-tab-button>
        <cs-tab-button [value]="IntakeStep.EnergyBalance" [disabled]="needsPlanRegeneration()"
          [showNotification]="showEnergyBalanceNotification">
          <cs-label>{{ STEP_TITLES[IntakeStep.EnergyBalance] }}</cs-label>
        </cs-tab-button>
      </cs-tab>
    </div>
    }
  </cs-header-content>
</cs-header>

@if (!loading) {
<cs-tab-content-container class="step-content-container" [selection]="currentStep"
  [attr.data-selected-step]="currentStep"
  [class.overview-mode]="!isNewMode() && currentView === IntakeView.ProgramOverview" vld-progress
  [(vldStep)]="intakeFormState.intakeFormProgress" (vldStepChange)="onIntakeProgressChanged()"
  [(vldTotalSteps)]="totalSteps" [vldDisableHiding]="true"
  [swipeEnabled]="hasClientSmallScreen() && isNewMode()" (swipeForward)="handleNextButton()" (swipeBack)="handleBackButton()">
  <!-- Step 1: Basic Info (new mode, or coach-managing review for #3389) -->
  @if (mode === 'new' || isCoachManaging()) {
  <cs-tab-content [value]="IntakeStep.BasicInfo">
    <cs-content [loading]="loading">
      <cs-card-list vld-group vldAutoScroll="true">
        <cs-info-card type="info" [dismissible]="true">
          {{ LL.intake.alerts.progressSaved() }}
        </cs-info-card>
        @if (mode === 'new') {
        <cs-card>
          <cs-card-content>
            <cs-item-list>
              <!-- Gender section -->
              <cs-item-group [title]="LL.intake.labels.gender()">
                <cs-radio-group inline [(selected)]="intakeFormState.gender" (selectedChange)="somethingChanged()">
                  <cs-radio [value]="Gender.male">{{ LL.intake.labels.male() }}</cs-radio>
                  <cs-radio [value]="Gender.female">{{ LL.intake.labels.female() }}</cs-radio>
                </cs-radio-group>
                <vld-message [validity]="validity('gender')"></vld-message>
              </cs-item-group>
              <!-- Birthdate section -->
              <cs-item-group [title]="LL.intake.labels.birthdate()">
                <input-calendar [(date)]="intakeFormState.born" (dateChange)="somethingChanged()" [placeholder]="datePlaceholder">
                </input-calendar>
                <vld-message [validity]="validity('birthday')"></vld-message>
              </cs-item-group>
              <!-- Height section -->
              <cs-item-group [title]="LL.intake.labels.height()">
                <cs-input-measure type="bodyheight_cm" [(userUnit)]="this.intakeFormState.height_unit"
                  [(canonValue)]="this.intakeFormState.height_cm" (canonValueChange)="somethingChanged()"
                  (userUnitChange)="somethingChanged()" input-sequence></cs-input-measure>
                <vld-message [validity]="validity('height')"></vld-message>
              </cs-item-group>
              <!-- Lock warning -->
              <cs-text-alert type="info" icon="lock-closed">
                {{ LL.intake.notes.immutableStats() }}
              </cs-text-alert>
            </cs-item-list>
          </cs-card-content>
        </cs-card>
        }
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 2: Body Composition (shown in new mode OR as tab) -->
  @if (isNewMode() || currentView === IntakeView.Tabs) {
  <cs-tab-content [value]="IntakeStep.BodyComposition">
    <cs-content [loading]="loading">
      <cs-card-list vld-group vldAutoScroll="true">
        <!-- Weight Card -->
        @if (shouldCheckForBodyWeight()) {
        <cs-card>
          <cs-card-title>{{ LL.intake.labels.weight() }}</cs-card-title>
          <cs-card-content>
            <cs-item>
              <cs-input-measure type="bodyweight_kg" [(userUnit)]="this.intakeFormState.weight_unit"
                [(canonValue)]="this.intakeFormState.weight_kg" (canonValueChange)="somethingChanged()"
                (userUnitChange)="somethingChanged()" input-sequence></cs-input-measure>
            </cs-item>
            <vld-message [validity]="validity('weight')"></vld-message>
          </cs-card-content>
        </cs-card>
        }
        <!-- Body Fat Percentage Card -->
        <cs-card>
          <cs-card-title>
            {{ LL.intake.labels.bodyfat() }}
            <help-icon name="info" helpId="@help:references.body-composition"></help-icon>
            <cs-note light>{{ LL.intake.notes.bodyfatEstimate() }}</cs-note>
          </cs-card-title>
          <cs-card-content>
            <bodyfat-input [(bfData)]="intakeFormState.bfData"
              [shouldOfferTapeMeasureMethod]="shouldOfferTapeMeasureForBF()" [gender]="intakeFormState.gender"
              (bfDataChange)="somethingChanged()" (methodChange)="onBodyFatMethodChange()"></bodyfat-input>
            <vld-message [validity]="validity('bf')"></vld-message>
            @if (canSkipBodyfatEstimate()) {
            <p class="skip-note">{{ LL.intake.strength.skipEstimate() }}</p>
            } @else {
            @if (!intakeFormState.bfData?.method) {
            <p class="validation-note">
              {{ LL.intake.validation.selectOption() }}
            </p>
            }
            }
            <div class="button-group">
              @if (canSkipBodyfatEstimate() && isNewMode()) {
              <cs-button [attr.fit-width]="hasClientSmallScreen() ? '' : null" secondary vld-button-skip
                (vldClickSkip)="bodyfatSkipped()" (click)="onBodyCompositionIntakeSectionSkipButtonClick()"
                icon="skip-forward" [label]="LL.intake.buttons.skip()"></cs-button>
              }
            </div>
          </cs-card-content>
        </cs-card>
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 3: Strength (new mode, or coach-managing review for #3389) -->
  @if (mode === 'new' || isCoachManaging()) {
  <cs-tab-content [value]="IntakeStep.Strength">
    <cs-content [loading]="loading">
      <cs-card-list vld-group vldAutoScroll="true">
        @if (shouldCheckForDeclaredStrength()) {
        <cs-card>
          <cs-card-title>
            {{ LL.intake.strength.liftingStatsOptional() }}
            <cs-note light>
              {{ LL.intake.strength.liftingStatsNote1() }}
              <strong>{{ LL.intake.strength.liftingStatsNoteHighlight() }}</strong>
              {{ LL.intake.strength.liftingStatsNote2() }}
            </cs-note>
          </cs-card-title>
          <cs-card-content>
            <!-- the strength tests could not be read: the saved answers are kept, and this message
                 blocks Next until a retry succeeds (#6540) -->
            @if (strengthTestsLoad === StrengthTestsLoad.ReadFailed) {
            <div class="strength-load-failed" e2e-locator="strength-load-failed">
              <p class="load-failed-note">{{ LL.intake.strength.loadFailed() }}</p>
              <vld-message [validity]="validity('strength/load')"></vld-message>
              <div class="button-group">
                <cs-button secondary icon="refresh" [label]="LL.common.buttons.tryAgain()"
                  (click)="retryStrengthTestsAsync()"></cs-button>
                <!-- the lifting stats are optional, so the user may go on without them; their
                     saved numbers are left as they are -->
                @if (isNewMode()) {
                <cs-button secondary vld-button-skip icon="skip-forward" [label]="LL.intake.buttons.skip()"
                  (vldClickSkip)="strengthTestsSkipped()"></cs-button>
                }
              </div>
            </div>
            } @else {
            <!-- Exercise list -->
            <div class="strength-exercises">
              @if (intakeFormState.declaredStrength?.slots) {
              @for (e of intakeFormState.declaredStrength.slots; track e.idSlot; let i = $index) {
              <div class="strength-exercise-item" [attr.e2e-locator]="'strength-exercise-' + i">
                <!-- Exercise selector with video icon -->
                <cs-form-field class="exercise-selector" [label]="getSlotName(e.idSlot)">
                  <div class="select-with-icon">
                    <!-- [ariaLabel] names the picker: the video icon beside it is a control of
                         its own, so there is no row text the select can take its name from -->
                    <cs-select [ariaLabel]="getSlotName(e.idSlot)"
                      [(value)]="e.idExercise" (valueChange)="onExerciseChanged(e)"
                      [placeholder]="LL.intake.strength.selectExercisePlaceholder()">
                      <!-- ex.exercise.name is an exercise-catalog name, out of scope for i18n
                           per this phase's PRD (database content localization is a separate project) -->
                      @for (ex of getExercisesForSlot(e.idSlot); track ex.exercise._id) {
                      <cs-select-option [value]="ex.exercise._id" [label]="ex.exercise.name | untranslated"></cs-select-option>
                      }
                    </cs-select>
                    @if (e.idExercise) {
                    <help-icon name="videocam" [helpId]="'@instructions:' + e.idExercise"></help-icon>
                    }
                  </div>
                  <!-- Bodyweight help text (only for BW exercises) -->
                  @if (e.idExercise && isTestingExerciseBW(e.idExercise)) {
                  <cs-note class="bw-help-text">
                    {{ LL.intake.strength.addedWeightOnly() }}
                  </cs-note>
                  }
                </cs-form-field>
                <!-- Weight and Reps inputs -->
                <div class="exercise-inputs-row">
                  <cs-form-field [label]="getWeightUnitLabel(e.stats.weight_unit)">
                    <cs-input-measure #weightInput type="addedweight_kg" [(userUnit)]="e.stats.weight_unit"
                      [(canonValue)]="e.stats.weight_kg" (canonValueChange)="onStrengthInputChanged()"
                      (userUnitChange)="onStrengthInputChanged()" [preselectValues]="getWeightPreselectValues(e.stats.weight_unit)"
                      [pairedWith]="repsInput" pairRole="primary" input-sequence
                      [attr.e2e-locator]="'strength-weight-' + i"></cs-input-measure>
                  </cs-form-field>
                  <cs-form-field [label]="LL.common.placeholders.reps()">
                    <cs-input-measure #repsInput [showUnit]="false" type="reps" [(canonValue)]="e.stats.reps"
                      (canonValueChange)="onStrengthInputChanged()" [preselectValues]="repsPreselectValues"
                      [pairedWith]="weightInput" pairRole="secondary" input-sequence
                      [attr.e2e-locator]="'strength-reps-' + i"></cs-input-measure>
                  </cs-form-field>
                </div>
                <vld-message [validity]="validity('strength/' + i)"></vld-message>
              </div>
              }
              }
            </div>
            }
          </cs-card-content>
        </cs-card>
        }
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 4: Lifestyle (shown in new mode OR as tab) -->
  @if (isNewMode() || currentView === IntakeView.Tabs) {
  <cs-tab-content [value]="IntakeStep.Lifestyle">
    <cs-content [loading]="loading">
      <cs-card-list vld-group vldAutoScroll="true">
        <cs-card>
          <cs-card-title>
            {{ LL.intake.lifestyle.activityLevel() }}
            <help-icon name="info" helpId="@help:references.sleep-activity-tdee"></help-icon>
          </cs-card-title>
          <cs-card-content>
            <cs-radio-group [(selected)]="intakeFormState.activityLevel" (selectedChange)="somethingChanged()">
              <cs-radio [value]="ActivityLevel.Sedentary">
                {{ LL.intake.lifestyle.sedentary() }}
                <cs-note>{{ LL.intake.lifestyle.sedentaryNote() }}</cs-note>
              </cs-radio>
              <cs-radio [value]="ActivityLevel.SomewhatActive">{{ LL.intake.lifestyle.somewhatActive() }}
                <cs-note>{{ LL.intake.lifestyle.somewhatActiveNote() }}</cs-note>
              </cs-radio>
              <cs-radio [value]="ActivityLevel.Active">
                {{ LL.intake.lifestyle.active() }}
                <cs-note>{{ LL.intake.lifestyle.activeNote() }}</cs-note>
              </cs-radio>
              <cs-radio [value]="ActivityLevel.VeryActive">
                {{ LL.intake.lifestyle.veryActive() }}
                <cs-note>{{ LL.intake.lifestyle.veryActiveNote() }}</cs-note>
              </cs-radio>
            </cs-radio-group>
            <vld-message [validity]="validity('activity')"></vld-message>
          </cs-card-content>
        </cs-card>
        <cs-card>
          <cs-card-title>{{ LL.intake.lifestyle.stressLevel() }}</cs-card-title>
          <cs-card-content>
            <cs-radio-group [(selected)]="intakeFormState.stressLevel" (selectedChange)="somethingChanged()">
              <cs-radio [value]="StressLevel.MildStress">
                {{ LL.intake.lifestyle.mildStress() }}
                <cs-note>{{ LL.intake.lifestyle.mildStressNote() }}</cs-note>
              </cs-radio>
              <cs-radio [value]="StressLevel.Average">
                {{ LL.intake.lifestyle.averageStress() }}
                <cs-note>{{ LL.intake.lifestyle.averageStressNote() }}</cs-note>
              </cs-radio>
              <cs-radio [value]="StressLevel.HighStress">
                {{ LL.intake.lifestyle.highStress() }}
                <cs-note>{{ LL.intake.lifestyle.highStressNote() }}</cs-note>
              </cs-radio>
            </cs-radio-group>
            <vld-message [validity]="validity('stress')"></vld-message>
          </cs-card-content>
        </cs-card>
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 5: Advanced Training (only in new mode) -->
  @if (mode === 'new') {
  <cs-tab-content [value]="IntakeStep.AdvancedTraining">
    <cs-content [loading]="loading">
      <advanced-methods-component vld-group vldAutoScroll="true" [state]="intakeFormState"
        (change)="advancedMethodsChanged()" (myoRepsChange)="advancedTrainingMethodsMyoRepsChanged()"
        (rmTestingChange)="advancedTrainingMethodsRMTestingChanged()"></advanced-methods-component>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 6: Schedule (shown in new mode OR as tab) -->
  @if (isNewMode() || currentView === IntakeView.Tabs) {
  <cs-tab-content [value]="IntakeStep.Schedule">
    <cs-content [loading]="loading">
      <cs-card-list vld-group vldAutoScroll="true">
        <cs-card>
          <cs-card-title>
            {{ LL.intake.schedule.trainingFrequency() }}
            <div title-action class="frequency-badge">
              <span class="frequency-label">{{ LL.intake.schedule.daysPerWeek() }}</span>
              <span class="frequency-value">{{ intakeFormState.trainingFrequency || 0 }}</span>
            </div>
            <cs-note light>{{ LL.intake.training.selectDaysNote() }}</cs-note>
          </cs-card-title>
          <cs-card-content>
            <cs-item-group>
              <cs-date-button-bar [selectedDays]="intakeFormState.trainingDays"
                (selectedDaysChange)="onTrainingDaysChange($event)">
              </cs-date-button-bar>
              @if (recommendations.trainingFrequencyText) {
              <cs-text-alert [type]="recommendations.trainingFrequencyGreat ? 'success-strong' : 'info'">
                {{ recommendations.trainingFrequencyText }}
                <help-link helpId="@help:references.training-volume">{{ LL.common.buttons.learnMore() }}</help-link>
              </cs-text-alert>
              }
              @if (recommendations.trainingDaysText) {
              <cs-text-alert type="info">
                {{ recommendations.trainingDaysText }}
                <help-link helpId="@help:references.training-volume">{{ LL.common.buttons.learnMore() }}</help-link>
              </cs-text-alert>
              }
              <vld-message [validity]="validity('frequency')"></vld-message>
            </cs-item-group>
          </cs-card-content>
        </cs-card>
        <!-- Morning Appetite Card -->
        @if (askMorningAppetite()) {
        <cs-card>
          <cs-card-title>
            {{ LL.intake.nutrition.morningAppetite() }}
            <cs-note light>{{ LL.intake.nutrition.morningAppetiteQuestion() }}</cs-note>
          </cs-card-title>
          <cs-card-content>
            <cs-item-group>
              <cs-radio-group inline [(selected)]="intakeFormState.morningAppetite"
                (selectedChange)="morningAppetiteChanged()">
                <cs-radio [value]="true">{{ LL.common.options.yes() }}</cs-radio>
                <cs-radio [value]="false">{{ LL.common.options.no() }}</cs-radio>
              </cs-radio-group>
            </cs-item-group>
            <vld-message [validity]="validity('morningAppetite')"></vld-message>
          </cs-card-content>
        </cs-card>
        }
        <!-- Meal Frequency Card -->
        <cs-card>
          <cs-card-title>
            {{ LL.intake.nutrition.mealFrequency() }}
            <div title-action class="frequency-badge">
              <span class="frequency-label">{{ LL.intake.schedule.mealsPerDay() }}</span>
              <span class="frequency-value">{{ intakeFormState.mealFrequency || 4 }}</span>
            </div>
            <cs-note light>{{ LL.intake.nutrition.mealFrequencyDescription() }}</cs-note>
          </cs-card-title>
          <cs-card-content>
            <cs-item-group>
              <cs-slider e2e-locator="meal-frequency-slider" [min]="1" [max]="6" [step]="1" [showPercentSign]="false"
                [(value)]="intakeFormState.mealFrequency" (valueChange)="mealFrequencyChanged()">
              </cs-slider>
              @if (recommendations.mealFrequencyText) {
              <cs-text-alert type="info">
                {{ recommendations.mealFrequencyText }}
                <help-link helpId="@help:intake.advanced-training-techniques-calorie-cycling">{{ LL.common.buttons.learnMore() }}</help-link>
              </cs-text-alert>
              }
              <vld-message [validity]="validity('meals')"></vld-message>
            </cs-item-group>
          </cs-card-content>
        </cs-card>
        <!-- Sleep Card -->
        <cs-card>
          <cs-card-title>
            {{ LL.intake.schedule.sleep() }}
            <div title-action class="frequency-badge">
              <span class="frequency-label">{{ LL.intake.schedule.hoursPerNight() }}</span>
              <span class="frequency-value">{{ intakeFormState.sleepHours || 6 }}</span>
            </div>
            <cs-note light>{{ LL.intake.schedule.sleepDescription() }}</cs-note>
          </cs-card-title>
          <cs-card-content>
            <cs-item-group>
              <cs-slider e2e-locator="sleep-hours-slider" [min]="2" [max]="12" [step]="1" [showPercentSign]="false"
                [forceTickmarks]="true" [(value)]="intakeFormState.sleepHours" (valueChange)="sleepHoursChanged()">
              </cs-slider>
              @if (recommendations.sleepText) {
              <cs-text-alert [type]="recommendations.sleepTextType || 'info'">
                {{ recommendations.sleepText }}
                <help-link helpId="@help:references.sleep-activity-tdee">{{ LL.common.buttons.learnMore() }}</help-link>
              </cs-text-alert>
              }
            </cs-item-group>
          </cs-card-content>
        </cs-card>
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 7: Nutrition Options (only in new mode) -->
  @if (mode === 'new') {
  <cs-tab-content [value]="IntakeStep.NutritionOptions">
    <cs-content [loading]="loading">
      <nutrition-options-component vld-group vldAutoScroll="true" [state]="intakeFormState"
        (change)="nutritionOptionsChanged()"></nutrition-options-component>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 8: Goals (shown in new mode OR as tab) -->
  @if (isNewMode() || currentView === IntakeView.Tabs) {
  <cs-tab-content [value]="IntakeStep.Goals">
    <cs-content [loading]="loading">
      <cs-card-list vld-group vldAutoScroll="true">
        <!-- Physique Goal Card -->
        <cs-card>
          <cs-card-title>
            {{ LL.intake.goals.physiqueGoal() }}
            <cs-note light>{{ LL.intake.goals.physiqueGoalQuestion() }}</cs-note>
          </cs-card-title>
          <cs-card-content>
            <cs-radio-group [(selected)]="intakeFormState.muscleGrowthPreferenceMain"
              (selectedChange)="goalPhysiqueChanged()">
              <cs-radio [value]="MuscleGrowthMain.Balanced">
                {{ LL.intake.goals.balanced() }}
                <cs-note>{{ LL.intake.goals.balancedNote() }}</cs-note>
              </cs-radio>
              <cs-radio [value]="MuscleGrowthMain.LowerBody">
                {{ LL.intake.goals.lowerBodyFocus() }}
                <cs-note>{{ LL.intake.goals.lowerBodyFocusNote() }}</cs-note>
              </cs-radio>
              <cs-radio [value]="MuscleGrowthMain.Custom">
                {{ LL.intake.goals.custom() }}
                <cs-note>{{ LL.intake.goals.customNote() }}</cs-note>
              </cs-radio>
            </cs-radio-group>
          </cs-card-content>
        </cs-card>
        <!-- Body Part Customization Card -->
        @if (intakeFormState.muscleGrowthPreferenceMain === MuscleGrowthMain.Custom) {
        <cs-card>
          <cs-card-title>
            {{ LL.intake.goals.bodyPartCustomization() }}
            <help-icon name="info" helpId="@help:references.training-volume"></help-icon>
            <cs-note light>{{ LL.intake.goals.customizationNote() }}</cs-note>
          </cs-card-title>
          <cs-card-content>
            <cs-item-group small [title]="LL.intake.goals.lowerBody()">
              <cs-table>
                @for (bodypart of lowerBodyParts; track bodypart) {
                <cs-table-row>
                  <cs-table-cell>
                    <cs-item class="body-part-item">
                      <cs-label>{{ bodyPartLabel(bodypart.id) }}</cs-label>
                      <cs-select class="muscle-group-select"
                        [(value)]="intakeFormState.muscleGrowthPreferenceTable[bodypart.id]"
                        (valueChange)="somethingChanged()">
                        <cs-select-option [value]="OneMuscleGrowthValue.Maximize"
                          [label]="LL.intake.goals.maximize()"></cs-select-option>
                        <cs-select-option [value]="OneMuscleGrowthValue.Maintain"
                          [label]="LL.intake.goals.maintain()"></cs-select-option>
                        <cs-select-option [value]="OneMuscleGrowthValue.Shrink"
                          [label]="LL.intake.goals.shrink()"></cs-select-option>
                      </cs-select>
                    </cs-item>
                  </cs-table-cell>
                </cs-table-row>
                }
              </cs-table>
            </cs-item-group>
            <cs-item-group small [title]="LL.intake.goals.upperBody()">
              <cs-table>
                @for (bodypart of upperBodyParts; track bodypart) {
                <cs-table-row>
                  <cs-table-cell>
                    <cs-item class="body-part-item">
                      <cs-label>{{ bodyPartLabel(bodypart.id) }}</cs-label>
                      <cs-select class="muscle-group-select"
                        [(value)]="intakeFormState.muscleGrowthPreferenceTable[bodypart.id]"
                        (valueChange)="somethingChanged()">
                        <cs-select-option [value]="OneMuscleGrowthValue.Maximize"
                          [label]="LL.intake.goals.maximize()"></cs-select-option>
                        <cs-select-option [value]="OneMuscleGrowthValue.Maintain"
                          [label]="LL.intake.goals.maintain()"></cs-select-option>
                        <cs-select-option [value]="OneMuscleGrowthValue.Shrink"
                          [label]="LL.intake.goals.shrink()"></cs-select-option>
                      </cs-select>
                    </cs-item>
                  </cs-table-cell>
                </cs-table-row>
                }
              </cs-table>
            </cs-item-group>
          </cs-card-content>
        </cs-card>
        }
        <!-- Primary Goal Card -->
        <cs-card>
          <cs-card-title>{{ LL.intake.goals.primaryGoal() }}</cs-card-title>
          <cs-card-content>
            <cs-radio-group [(selected)]="intakeFormState.trainingGoalGrowth" (selectedChange)="trainingGoalChanged()">
              @if (mode !== 'new') {
              @switch (recommendedGoalSwitch()) {
              @case (TrainingGoal.MuscleGrowth) {
              <cs-note>{{ LL.intake.training.recommendSwitchToMuscleGrowth() }}</cs-note>
              }
              @case (TrainingGoal.FatLoss) {
              <cs-note>{{ LL.intake.training.recommendSwitchToFatLoss() }}</cs-note>
              }
              }
              }
              @if (shouldOfferAutomaticTrainingGoal()) {
              <cs-radio [value]="TrainingGoal.Automatic">
                {{ LL.intake.goals.decideForMe() }}
                <cs-note>{{ LL.intake.goals.decideForMeDescription() }}</cs-note>
              </cs-radio>
              }
              <cs-radio [value]="TrainingGoal.FatLoss">
                {{ LL.intake.goals.fatLoss() }}
                <cs-note>{{ LL.intake.goals.fatLossDescription() }}</cs-note>
              </cs-radio>
              <cs-radio [value]="TrainingGoal.MuscleGrowth">
                {{ LL.intake.goals.muscleGrowth() }}
                <cs-note>{{ LL.intake.goals.muscleGrowthDescription() }}</cs-note>
              </cs-radio>
            </cs-radio-group>
            <vld-message [validity]="validity('goal')" #goalVldMessage></vld-message>
          </cs-card-content>
        </cs-card>
        <!-- Test Mode Options Card -->
        @if (settings.testMode) {
        <cs-card>
          <cs-card-title>{{ LL.intake.testMode.options() }}</cs-card-title>
          <cs-card-content>
            <cs-item>
              <cs-label>{{ LL.intake.advancedLabels.progressionTesting() }}</cs-label>
              <cs-toggle item-content [(checked)]="settings.progressionTesting"></cs-toggle>
            </cs-item>
            @if (settings.progressionTesting) {
            <!-- Test-mode-only developer field (settings.testMode gate): placeholder is a
                 raw internal slot id example, not display prose -->
            <cs-item-group small [title]="LL.intake.advancedLabels.slot()">
              <cs-input [placeholder]="'slot/$squat' | untranslated" [(value)]="settings.progressionTesting_Slot"></cs-input>
            </cs-item-group>
            <cs-item-group small [title]="LL.intake.advancedLabels.sets()">
              <cs-input-measure type="number" [(canonValue)]="settings.progressionTesting_Sets" input-sequence>
              </cs-input-measure>
            </cs-item-group>
            <cs-item-group small [title]="LL.intake.advancedLabels.level()">
              <cs-select [(value)]="settings.progressionTesting_Level"
                (valueChange)="onProgressionTestingLevelChanged()">
                <cs-select-option [value]="TrainingLevel.Novice"
                  [label]="LL.intake.testMode.novice()"></cs-select-option>
                <cs-select-option [value]="TrainingLevel.Intermediate"
                  [label]="LL.intake.testMode.intermediate()"></cs-select-option>
                <cs-select-option [value]="TrainingLevel.Advanced"
                  [label]="LL.intake.testMode.advanced()"></cs-select-option>
              </cs-select>
            </cs-item-group>
            <cs-item-group small [title]="LL.intake.advancedLabels.otherSlotsLevel()">
              <cs-select [(value)]="settings.progressionTesting_otherLevel">
                <cs-select-option [value]="TrainingLevel.Novice"
                  [label]="LL.intake.testMode.novice()"></cs-select-option>
                <cs-select-option [value]="TrainingLevel.Intermediate"
                  [label]="LL.intake.testMode.intermediate()"></cs-select-option>
                <cs-select-option [value]="TrainingLevel.Advanced"
                  [label]="LL.intake.testMode.advanced()"></cs-select-option>
              </cs-select>
            </cs-item-group>
            <cs-item-group small [title]="LL.intake.advancedLabels.intensityPeriodization()">
              <cs-select [(value)]="settings.progressionTesting_Intensity">
                <cs-select-option [value]="IntensityLevel.Initial"
                  [label]="LL.intake.testMode.initial()"></cs-select-option>
                @if (settings.progressionTesting_Level === TrainingLevel.Novice) {
                <cs-select-option [value]="IntensityLevel.Intensified"
                  [label]="LL.common.programTypes.intensified()"></cs-select-option>
                }
                @if (settings.progressionTesting_Level >= TrainingLevel.Intermediate) {
                <cs-select-option [value]="IntensityLevel.DUPheavy"
                  [label]="LL.common.programTypes.dup()"></cs-select-option>
                }
                @if (settings.progressionTesting_Level === TrainingLevel.Advanced) {
                <cs-select-option [value]="IntensityLevel.TUPheavy"
                  [label]="LL.common.programTypes.tup()"></cs-select-option>
                }
              </cs-select>
            </cs-item-group>
            <!-- Test-mode-only developer field (settings.testMode gate): placeholder is a
                 raw JSON example, not display prose -->
            <cs-item-group small [title]="LL.intake.advancedLabels.slotIntensitiesJSON()">
              <cs-input [placeholder]="'{}' | untranslated" [(value)]="settings.progressionTesting_SlotIntensities"></cs-input>
            </cs-item-group>
            }
          </cs-card-content>
        </cs-card>
        }
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 9: Training Volume (shown in new mode OR as tab) -->
  @if (isNewMode() || currentView === IntakeView.Tabs) {
  <cs-tab-content [value]="IntakeStep.TrainingVolume">
    <cs-content [loading]="loading">
      <cs-card-list vld-group vldAutoScroll="true">
        @if (intakeFormState.maxEffortPlan && intakeFormState.trainingVolumeWeeklyAvg !== undefined) {
        <cs-card id="trainingVolumeCard">
          <cs-card-title>
            {{ LL.intake.goals.trainingVolume() }}
            <help-icon name="info" helpId="@help:references.training-volume"></help-icon>
            <div title-action class="frequency-badge">
              <span class="frequency-label">{{ LL.intake.training.setsPerWeek() }}</span>
              <span #trainingVolumeBadgeValue class="frequency-value">{{
                Math.round(intakeFormState.trainingVolumeWeeklyAvg) }}</span>
            </div>
            <cs-note light>{{ LL.intake.training.volumeDescription() }}</cs-note>
            @if (currentTrainingVolumeWeeklyAvg !== undefined) {
            <cs-note light>{{ LL.intake.training.currentPlanVolume({volume: Math.round(currentTrainingVolumeWeeklyAvg)})
              }}</cs-note>
            }
          </cs-card-title>
          <cs-card-content>
            <cs-item-group>
              <cs-slider id="trainingVolumeWeeklyAvgSlider"
                [min]="Math.round(intakeFormState.maxEffortPlan.trainingVolumeWeeklyAvg * 0.1)" [max]="40"
                [highlightedValues]="trainingVolumeSliderHighlightedValues"
                [(value)]="intakeFormState.trainingVolumeWeeklyAvg" [step]="1"
                [tickmarks]="trainingVolumeWeeklyAvgTickmarks"
                (valueChange)="handleTrainingVolumeWeeklyAvgSliderValueChange()"
                [customBackgroundGradientMarks]="trainingVolumeSliderTrackBackgroundGradientMarks"
                [showPercentSign]="false">
              </cs-slider>
              <cs-radio-group [selected]="getSelectedTrainingDedicationLevel()"
                (selectedChange)="trainingDedicationLevelChanged($event)">
                <cs-radio [value]="DedicationLevel.SlowAndSteady"
                  [recommended]="getSuggestedTrainingDedicationLevel() === DedicationLevel.SlowAndSteady">
                  {{ LL.intake.training.slowAndSteady() }}
                  <cs-note>{{ LL.intake.training.slowAndSteadyDescription() }}</cs-note>
                </cs-radio>
                <cs-radio [value]="DedicationLevel.Balanced"
                  [recommended]="getSuggestedTrainingDedicationLevel() === DedicationLevel.Balanced">
                  {{ LL.intake.training.balanced() }}
                  <cs-note>{{ LL.intake.training.balancedDescription() }}</cs-note>
                </cs-radio>
                <cs-radio [value]="DedicationLevel.MaximumEffort"
                  [recommended]="getSuggestedTrainingDedicationLevel() === DedicationLevel.MaximumEffort">
                  {{ LL.intake.training.maximumEffort() }}
                  <cs-note>{{ LL.intake.training.maximumEffortDescription() }}</cs-note>
                  @if (intakeFormState.trainingVolumeWeeklyAvg > getTrainingVolumeOverboardLimit()) {
                  <cs-text-alert type="warning">
                    {{ LL.intake.training.overreachingWarning() }}
                  </cs-text-alert>
                  }
                </cs-radio>
              </cs-radio-group>
            </cs-item-group>
          </cs-card-content>
        </cs-card>
        <!-- Workout split (#4591), see design-docs/training-splits.md. An option the user
             does not train often enough for is shown DISABLED, never hidden. -->
        <cs-card id="trainingSplitCard">
          <cs-card-title>
            {{ LL.intake.trainingSplit.title() }}
          </cs-card-title>
          <cs-card-content>
            <cs-radio-group [selected]="intakeFormState.trainingSplitMode || TrainingSplitMode.Optimal"
              (selectedChange)="trainingSplitModeChanged($event)">
              <cs-radio id="trainingSplitOptimal" [value]="TrainingSplitMode.Optimal" [recommended]="true">
                {{ LL.intake.trainingSplit.optimal() }}
                <cs-note>{{ getTrainingSplitNote(TrainingSplitMode.Optimal) }}</cs-note>
              </cs-radio>
              <cs-radio id="trainingSplitPushPullLegs" [value]="TrainingSplitMode.PushPullLegs"
                [disabled]="!isTrainingSplitAvailable(TrainingSplitMode.PushPullLegs)">
                {{ LL.intake.trainingSplit.pushPullLegs() }}
                <cs-note>{{ getTrainingSplitNote(TrainingSplitMode.PushPullLegs) }}</cs-note>
              </cs-radio>
              <cs-radio id="trainingSplitUpperLower" [value]="TrainingSplitMode.UpperLower"
                [disabled]="!isTrainingSplitAvailable(TrainingSplitMode.UpperLower)">
                {{ LL.intake.trainingSplit.upperLower() }}
                <cs-note>{{ getTrainingSplitNote(TrainingSplitMode.UpperLower) }}</cs-note>
              </cs-radio>
              <cs-radio id="trainingSplitFullBody" [value]="TrainingSplitMode.FullBody"
                [disabled]="!isTrainingSplitAvailable(TrainingSplitMode.FullBody)">
                {{ LL.intake.trainingSplit.fullBody() }}
                <cs-note>{{ getTrainingSplitNote(TrainingSplitMode.FullBody) }}</cs-note>
              </cs-radio>
            </cs-radio-group>
          </cs-card-content>
        </cs-card>
        }
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 10: Energy Balance (shown in new mode OR as tab) -->
  @if (isNewMode() || currentView === IntakeView.Tabs) {
  <cs-tab-content [value]="IntakeStep.EnergyBalance">
    <cs-content [loading]="loading">
      <cs-card-list vld-group vldAutoScroll="true">
        @if (intakeFormState.maxEffortPlan && intakeFormState.intakeDeltaPercent !== undefined) {
        <cs-card id="energyBalanceCard">
          <cs-card-title>
            {{ LL.intake.training.calorie() }} {{intakeFormState.maxEffortPlan.intakeDeltaPercent > 0 ?
            'surplus'
            : 'deficit'}}
            <help-icon name="info" helpId="@help:references.calorie-targets"></help-icon>
            <div title-action class="frequency-badge">
              <span class="frequency-label">{{ intakeFormState.maxEffortPlan.intakeDeltaPercent > 0 ?
                LL.intake.training.calorieSurplus() : LL.intake.training.calorieDeficit() }}</span>
              <span #intakeDeltaBadgeValue class="frequency-value">{{
                Math.abs(roundToPrecision(intakeFormState.intakeDeltaPercent, 0.1)) }}%</span>
            </div>
            <cs-note light>
              @if (intakeFormState.maxEffortPlan.intakeDeltaPercent > 0) {
              {{ LL.intake.planOverview.gainWeightQuicker() }}
              }
              @if (intakeFormState.maxEffortPlan.intakeDeltaPercent < 0) { {{ LL.intake.planOverview.loseWeightQuicker()
                }} } </cs-note>
                @if (currentIntakeDeltaPercent !== undefined) {
                <cs-note light>{{ LL.intake.planOverview.currentPlan({percent:
                  roundToPrecision(currentIntakeDeltaPercent * 100, 0.1)}) }}</cs-note>
                }
          </cs-card-title>
          <cs-card-content>
            <cs-item-group>
              <cs-slider id="intakeDeltaPercentSlider"
                [min]="intakeFormState.maxEffortPlan.intakeDeltaPercent < 0 ? -50 : 0"
                [max]="intakeFormState.maxEffortPlan.intakeDeltaPercent > 0 ? Math.max(Math.round(intakeFormState.maxEffortPlan.intakeDeltaPercent * 100), 30) : 0"
                [highlightedValues]="intakeDeltaPercentSliderHighlightedValues"
                [(value)]="intakeFormState.intakeDeltaPercent" [step]="0.5" [tickmarks]="intakeDeltaPercentTickmarks"
                (valueChange)="handleIntakeDeltaPercentSliderValueChange()"
                [customBackgroundGradientMarks]="intakeDeltaPercentSliderTrackBackgroundGradientMarks">
              </cs-slider>
              <cs-radio-group [selected]="getSelectedNutritionDedicationLevel()"
                (selectedChange)="nutritionDedicationLevelChanged($event)">
                <cs-radio [value]="DedicationLevel.SlowAndSteady"
                  [recommended]="getSuggestedNutritionDedicationLevel() === DedicationLevel.SlowAndSteady">
                  {{ LL.intake.dedication.slowAndSteady() }}
                  <cs-note>{{ LL.intake.dedication.slowAndSteadyNote() }}</cs-note>
                </cs-radio>
                <cs-radio [value]="DedicationLevel.Balanced"
                  [recommended]="getSuggestedNutritionDedicationLevel() === DedicationLevel.Balanced">
                  {{ LL.intake.dedication.balanced() }}
                  <cs-note>{{ LL.intake.dedication.balancedNote() }}</cs-note>
                </cs-radio>
                <cs-radio [value]="DedicationLevel.MaximumEffort"
                  [recommended]="getSuggestedNutritionDedicationLevel() === DedicationLevel.MaximumEffort">
                  {{ LL.intake.dedication.maximumEffort() }}
                  <cs-note>{{ LL.intake.dedication.maximumEffortNote() }}</cs-note>
                  @if (Math.abs(intakeFormState.intakeDeltaPercent) >
                  (Math.abs(getIntakeDeltaPercentForDedicationLevel(DedicationLevel.MaximumEffort)) + 0.5)) {
                  <cs-text-alert type="warning">
                    @if (intakeFormState.intakeDeltaPercent < 0) { {{ LL.intake.planOverview.muscleLossWarning() }} }
                      @if (intakeFormState.intakeDeltaPercent> 0) {
                      {{ LL.intake.planOverview.fatGainWarning() }}
                      }
                  </cs-text-alert>
                  }
                </cs-radio>
              </cs-radio-group>
            </cs-item-group>
          </cs-card-content>
        </cs-card>
        }
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 11: Program Overview (shown in new mode OR in overview view) -->
  @if (isNewMode() || currentView === IntakeView.ProgramOverview) {
  <cs-tab-content [value]="IntakeStep.ProgramOverview">
    <cs-content [loading]="loading">
      <!-- Success Alert -->
      <cs-card-list vld-group vldAutoScroll="true">
        @if (generatedFitnessPlan) {
        @if (skipPlanRegeneration) {
        <cs-info-card type="info" [dismissible]="false">
          {{ LL.intake.planOverview.keepingProgramAlert() }}
        </cs-info-card>
        } @else {
        <cs-info-card type="info" [dismissible]="false">
          {{ LL.intake.planOverview.successAlert() }}
        </cs-info-card>
        }
        }
        <!-- Nutrition Plan Card -->
        @if (intakeFormState.nutritionCoaching !== NutritionCoachingType.None && generatedFitnessPlan) {
        <cs-nutrition-plan-card [nutrition]="nutrition" [trainingGoal]="trainingGoalForNutritionCard" [editable]="true"
          (edit)="handleEditNutritionPlan()">
        </cs-nutrition-plan-card>
        }
      </cs-card-list>
      <!-- Workouts and Muscle Volume section -->
      @if (generatedFitnessPlan && intakeFormState.maxEffortPlan && programOverview) {
      <cs-card-list>
        <cs-card class="workouts-card">
          <cs-card-title>
            {{ LL.intake.planOverview.workouts({count: programOverview.workouts.list.length}) }}
            <cs-button title-action tertiary small [label]="LL.intake.planOverview.edit()" icon="edit"
              (click)="handleEditTrainingProgram()"></cs-button>
            <cs-note light>
              {{ LL.intake.planOverview.workoutsDescription() }}
              <help-link helpId="@help:training.programming-education">{{ LL.intake.planOverview.learnMoreProgramming()
                }}</help-link>
            </cs-note>
          </cs-card-title>
          <cs-card-content>
            <cs-workout-overview [workouts]="programOverview.workouts"
              [(selectedWorkout)]="selectedWorkout"></cs-workout-overview>
          </cs-card-content>
        </cs-card>
        <cs-card class="muscle-volume-card">
          <cs-card-title>
            {{ LL.training.trainingProgram.muscleVolume() }}
            <help-icon name="info" helpId="@help:references.training-volume"></help-icon>
          </cs-card-title>
          <cs-card-content>
            <cs-muscle-volume [lowerBodyMuscles]="programOverview.lowerBodyMuscles"
              [upperBodyMuscles]="programOverview.upperBodyMuscles"></cs-muscle-volume>
          </cs-card-content>
        </cs-card>
      </cs-card-list>
      }
    </cs-content>
  </cs-tab-content>
  }
  <!-- Step 12: First-workout handoff (#4059) — new end users only. A display-only step
       (its vld-group is what makes it count as step 12) that hands the user off from
       "plan is ready" into their first workout. Coaches never reach this step. -->
  @if (isFirstWorkoutHandoffEligible()) {
  <cs-tab-content [value]="IntakeStep.FirstWorkoutHandoff">
    <cs-content [loading]="loading">
      <cs-card-list vld-group>
        <cs-card class="first-workout-handoff-card">
          <cs-card-content>
            <div class="handoff-heading">{{ LL.intake.firstWorkout.heading() }}</div>
            <div class="handoff-subheading">{{ LL.intake.firstWorkout.subheading() }}</div>
            <ol class="handoff-steps">
              <li>
                <span class="handoff-step-number">1</span>
                <span class="handoff-step-text">{{ LL.intake.firstWorkout.step1() }}</span>
              </li>
              <li>
                <span class="handoff-step-number">2</span>
                <span class="handoff-step-text">{{ LL.intake.firstWorkout.step2() }}</span>
              </li>
            </ol>
          </cs-card-content>
        </cs-card>
      </cs-card-list>
    </cs-content>
  </cs-tab-content>
  }
</cs-tab-content-container>
}

<cs-page-action-buttons
  [class.vertical]="isFirstWorkoutHandoffEligible() && intakeFormState.intakeFormProgress === IntakeStep.FirstWorkoutHandoff">

  <!-- NEW MODE: Back/Next/Finish + first-workout handoff (#4059) -->
  @if (isNewMode()) {
  <!-- Back on every step except the first-workout handoff (step 12): the handoff is the
       "commit now" moment — the plan can still be edited from Program Overview (step 11),
       and "Finish, I'll start later" is the non-committal exit, so no Back is offered here -->
  @if (intakeFormState.intakeFormProgress > 1 && intakeFormState.intakeFormProgress !== IntakeStep.FirstWorkoutHandoff) {
  <cs-button medium secondary [label]="LL.intake.buttons.back()" (click)="handleBackButton()"></cs-button>
  }
  <!-- Steps 1-10: Next -->
  @if (intakeFormState.intakeFormProgress < IntakeStep.ProgramOverview) { <cs-button medium
    [label]="LL.intake.buttons.next()" [id]="nextButtonId" [class.has-validation-errors]="isNextButtonDisabled()"
    (click)="handleNextButton()"></cs-button>
    }
    <!-- Step 11 Program Overview: new end users continue to the handoff (step 12);
         coaches finish here as before -->
    @if (intakeFormState.intakeFormProgress === IntakeStep.ProgramOverview) {
    @if (isFirstWorkoutHandoffEligible()) {
    <cs-button medium [label]="LL.intake.buttons.next()" [id]="nextButtonId"
      [class.has-validation-errors]="isNextButtonDisabled()" (click)="handleNextButton()"></cs-button>
    } @else {
    <cs-button medium [label]="LL.common.buttons.finish()" (click)="handleFinishButton($event)"></cs-button>
    }
    }
    <!-- Step 12 First-workout handoff (new end users only): Start / Finish-later. Gated on
         eligibility (matching the step-12 tab content) so the footer can never render
         without its card for an ineligible viewer that somehow sits on step 12 -->
    @if (isFirstWorkoutHandoffEligible() && intakeFormState.intakeFormProgress === IntakeStep.FirstWorkoutHandoff) {
    @if (hasStartableFirstWorkout) {
    <cs-button medium primary [label]="LL.intake.firstWorkout.startButton()"
      (click)="handleStartFirstWorkout($event)"></cs-button>
    }
    <cs-button medium secondary [label]="LL.intake.firstWorkout.finishLaterButton()"
      (click)="handleFinishLater($event)"></cs-button>
    }
    }

    <!-- TAB VIEW: Cancel + Save & Update -->
    @if (!isNewMode() && currentView === IntakeView.Tabs) {
    <cs-button medium secondary [label]="LL.common.buttons.cancel()" (click)="handleCancelFromTabs($event)"></cs-button>
    <cs-button medium primary [label]="LL.intake.buttons.saveAndUpdate()" [disabled]="needsPlanRegeneration()"
      (click)="handleSaveAndUpdate()"></cs-button>
    }

    <!-- OVERVIEW VIEW: Cancel + Finish -->
    @if (!isNewMode() && currentView === IntakeView.ProgramOverview) {
    <cs-button medium secondary [label]="LL.common.buttons.cancel()" (click)="handleCancelFromOverview()"></cs-button>
    <cs-button medium primary [label]="LL.common.buttons.finish()" (click)="handleFinishFromOverview($event)"></cs-button>
    }

</cs-page-action-buttons>